import React, { useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'
import { Props as LocationSearchFieldProps } from 'components/SearchV2/Components/LocationSearchField/LocationSearchField'
import LocationSearchField from 'components/SearchV2/Components/LocationSearchField/LocationSearchField'
import LocationSearchFieldMenu from './LocationSearchFieldMenu'
import LocationSearchFieldControl from './LocationSearchFieldControl'
import LocationSearchFieldPlaceholder from './LocationSearchFieldPlaceholder'
import LocationSearchFieldMenuList from './LocationSearchFieldMenuList'
import { LOCATION_SEARCH_INPUT_PLACEHOLDER_LABEL } from 'constants/search'

const defaultCustomComponents = {
  Menu: LocationSearchFieldMenu,
  MenuList: LocationSearchFieldMenuList,
  Control: LocationSearchFieldControl,
  Placeholder: LocationSearchFieldPlaceholder,
}

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
`

const StyledLocationSearchField = styled(LocationSearchField)`
  flex: 1;

  .select-dropdown__menu-notice--no-options {
    padding: 0;
    text-align: unset;
  }
`

const LocationSearchFieldMobile = React.forwardRef((props: LocationSearchFieldProps, ref) => {
  const { placeholder = LOCATION_SEARCH_INPUT_PLACEHOLDER_LABEL, customComponents, ...rest } = props

  const selectRef = useRef(null)
  useImperativeHandle(ref, () => selectRef.current)

  return (
    <Container>
      <StyledLocationSearchField
        isClearable
        customComponents={{ ...defaultCustomComponents, ...customComponents }}
        placeholder={placeholder}
        ref={selectRef}
        {...rest}
      />
    </Container>
  )
})

export default LocationSearchFieldMobile
